import Vue from 'vue'
import {
  Autocomplete,
  Carousel,
  CarouselItem,
  Cascader,
  Dialog,
  Input,
  Image,
  Notification,
  Option,
  Pagination,
  Select,
  OptionGroup,
  Tag
} from 'element-ui'
Vue.use(Autocomplete)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Cascader)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Image)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Tag)
Vue.prototype.$notify = Notification
// import Element from 'element-ui'
// import locale from 'element-ui/lib/locale/lang/en'

// Vue.use(Element, { locale })
